import { Box, Stack, Typography, useTheme } from '@mui/material'
import EntryValue from './EntryValue'
import { LockButton } from './LockButton'
import { RevertButton } from './RevertButton'

import { formatAttributeName } from '../../../../../../utilities/formatting'
import { getPlatform } from '../../../../../../utilities/orientationAndPlatform'
import { Grid2 } from "@mui/material"

export default function Entry({...params}){

    let pageMode = params.pageMode

    let setStateObjectEntryHelper = params.setStateObjectEntryHelper
    let setStateObjectEntryFieldHelper = params.setStateObjectEntryFieldHelper

    let title = params.title

    let stateObject = params.stateObject
    let oldValue = stateObject[title].oldValue
    let currentInput = stateObject[title].currentInput
    let lockState = stateObject[title].lockState
    let focusState = stateObject[title].focusState

    let theme = useTheme()

    
    let platform = getPlatform()
    let containerBoxWidth = ''
    let titleBoxWidth = ''
    let valueBoxWidth = ''
    let buttonBoxWidth = ''
    if (platform === 'desktop' && pageMode === 'read'){
        containerBoxWidth = '623px'
        titleBoxWidth = '470px'
        valueBoxWidth = '150px'
    }

    else if (platform === 'mobile' && pageMode === 'read'){
        containerBoxWidth = '420px'
        titleBoxWidth = '317px'
        valueBoxWidth = '100px'
    }

    else if (platform === 'desktop' && pageMode === 'edit') {
        buttonBoxWidth = '60px'
        containerBoxWidth = '623px'
        titleBoxWidth = '364px'
        valueBoxWidth = '130px'
    }

    else if (platform === 'mobile' && pageMode === 'edit'){
        buttonBoxWidth = '40px'
        containerBoxWidth = '420px'
        titleBoxWidth = '' //variable
        valueBoxWidth = '' //variable
    }
    console.log(platform)


    
    const handleLockClick = (event) => {
        event.preventDefault()

        if (lockState){
            setStateObjectEntryFieldHelper(title, 'lockState', false)
        }


        else if (!lockState) {

            if (currentInput === 'valid'){

                let updatedEntry = {
                    oldValue: oldValue,
                    currentValue: currentInput,
                    currentInput: "",
                    lockState: true,
                    updatedState: true,
                    focusState: false,
                }

                setStateObjectEntryHelper(title, updatedEntry)
            }

            else if (currentInput !== 'valid'){
                console.log('input invalid')
                setStateObjectEntryFieldHelper(title, 'lockState', true)
            }
        }
    }


    const handleRevertClick = (event) => {
        event.preventDefault()
        let prevEntry = {
            oldValue: oldValue,
            currentValue: "",
            currentInput: "",
            lockState: true,
            updatedState: false,
            focusState: false,
        }
        setStateObjectEntryHelper(title, prevEntry)
    }

    const toggleFocus = (event) => {
        event.preventDefault()
        if (focusState) setStateObjectEntryFieldHelper(title, 'focusState', false)
        else if (!focusState) setStateObjectEntryFieldHelper(title, 'focusState', true)
    }




    let formattedTitle = formatAttributeName(title)

    return (
        <>
            <Grid2 container width={containerBoxWidth}>
                <Stack direction={'row'} spacing={'3px'}  id={'hi'}> 

                    <Box display={'flex'} justifyContent={'flex-end'} width={titleBoxWidth} height={'50px'} padding={'20px'} backgroundColor={theme.palette.NewChannelPage.foreground} id={'TitleBox'}>
                        <Typography alignSelf={'center'} fontSize={'18px'} fontWeight={700}>{formattedTitle}</Typography>
                    </Box>

                    <Box display={'flex'} justifyContent={'center'} width={valueBoxWidth} height={'50px'} padding={'20px'} backgroundColor={theme.palette.NewChannelPage.foreground} id={'EntryValueBox'}>
                        <EntryValue 
                            pageMode={pageMode}
                            stateObject={stateObject}
                            setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper}
                            title={title}
                            toggleFocus={toggleFocus}
                        />
                    </Box>

                    {(pageMode === 'edit') && (
                        <Stack direction={'row'}>
                            <Box display={'flex'} justifyContent={'center'} gap={'3px'} height={'50px'} width={buttonBoxWidth} backgroundColor={theme.palette.NewChannelPage.foreground}>
                                <LockButton stateObject={stateObject} title={title} handleLockClick={handleLockClick} />
                            </Box>

                            <Box display={'flex'} justifyContent={'center'} gap={'3px'} height={'50px'} width={buttonBoxWidth} backgroundColor={theme.palette.NewChannelPage.foreground}>
                                <RevertButton stateObject={stateObject} title={title} handleRevertClick={handleRevertClick} />
                            </Box>
                        </Stack>
                    )}
                </Stack>
            </Grid2>
        </>
    )
}
